import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { initI18n } from './i18n';
import './styles/index.css';

/**
 * Punto di ingresso unico.
 *
 * L'i18n viene inizializzato PRIMA del primo render: montare l'app e poi
 * caricare le traduzioni produrrebbe un lampeggio di chiavi grezze
 * (`comune_tab_overview` al posto di "Panoramica"), che è quello che faceva
 * il motore custom del portale statico.
 */
const container = document.getElementById('root');
if (!container) throw new Error('#root non trovato in index.html');

void initI18n().then(() => {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
